module.exports = __webpack_public_path__ + "media/images/noimage-user-2944b22d334e7bd11538ac061fff2daf.png";